import { logError, logMessage } from '../../../common/js/sentry';
import uuidv4 from 'uuid/v4';

export const videoMp4Base64 =
  'data:video/mp4;base64,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';

interface TrackingUrlContext {
  campaignId?: string;
  richadvertId?: string;
  advertiserId?: string;
  impressionId?: string;
  apikey?: string;
  aaid?: string;
  sdkVersion?: string;
  deviceOs?: string;
  appBundle?: string;
  page?: string;
  domain?: string;
  ioId?: string;
  userInstanceToken?: string;
  gdpr?: boolean;
  tcfv2?: string;
  creativeId?: string;
}

export function getTrackingUrlMacros(
  context: TrackingUrlContext = {}
): Record<string, any> {
  const macros: Record<string, any> = {};

  let isGdpr: string = '';
  if (typeof context.gdpr === 'boolean') {
    isGdpr = context.gdpr ? '1' : '0';
  }
  const lowercaseMacros: Record<string, any> = {
    timestamp: new Date().toISOString(),
    random: uuidv4(),
    campaignid: context.campaignId,
    richadvertid: context.richadvertId,
    advertiser_id: context.advertiserId,
    advert_id: context.impressionId,
    'aaid-optout': 0,
    apikey: context.apikey,
    aaid: context.aaid,
    user_advertising_id: context.aaid,
    sdk: context.sdkVersion,
    device_os: context.deviceOs,
    app_bundle: context.appBundle,
    page: context.page,
    domain: context.domain,
    io_id: context.ioId,
    user_instance_token: context.userInstanceToken,
    gdpr: isGdpr,
    tcfv2: context.tcfv2,
    creative_id: context.creativeId
  };

  Object.keys(lowercaseMacros).forEach(macro => {
    macros[macro] = lowercaseMacros[macro];
    macros[macro.toLocaleUpperCase()] = lowercaseMacros[macro];
  });

  return macros;
}

export function getUrl(url: string): { status: string; value: string } {
  try {
    const xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', url, false);
    xmlHttp.send(null);
    return {
      status: 'ok',
      value: xmlHttp.responseText
    };
  } catch (e) {
    throw e;
  }
}

function waitForVideoElement(elementId: string): Promise<void> {
  return new Promise((resolve, reject) => {
    let tryNb = 0;
    const interval = setInterval(function() {
      if (document.getElementById(elementId)) {
        clearInterval(interval);
        return resolve();
      }
      if (tryNb > 5) {
        clearInterval(interval);
        return reject(new Error('[AutoPlay] - Video Element not found in DOM'));
      }
      tryNb++;
    }, 100);
  });
}

function hasVideoStarted(
  videoElement: HTMLVideoElement,
  playPromise: Promise<void> | undefined,
  timeout: number = 500
): Promise<boolean> {
  return new Promise(resolve => {
    setTimeout(function() {
      if (
        !videoElement.paused ||
        ('Promise' in window && playPromise instanceof Promise)
      ) {
        return resolve(true);
      }

      return resolve(false);
    }, timeout);
  });
}

const VIDEO_AUTO_PLAY_TEST_ID = 'videoAutoPlayTestId';

function createVideoElement(): Promise<HTMLVideoElement> {
  const video = document.createElement('video');
  video.id = VIDEO_AUTO_PLAY_TEST_ID;
  (video as any).type = 'video/mp4';
  video.src = videoMp4Base64;

  const mp4 = document.createElement('source');
  mp4.type = 'video/mp4';
  mp4.src = videoMp4Base64;

  video.appendChild(mp4);

  video.muted = true;
  video.loop = true;
  video.autoplay = true;
  video.setAttribute('playsInline', 'true');
  video.style.display = 'none';

  const body = document.getElementsByTagName('body')[0];
  body.appendChild(video);

  return waitForVideoElement(VIDEO_AUTO_PLAY_TEST_ID).then(() => video);
}

function removeVideoElement(videoElement: HTMLVideoElement | null): void {
  if (videoElement) {
    const body = document.getElementsByTagName('body')[0];
    body.removeChild(videoElement);
  }
}

export function deviceSupportsAutoPlay(
  timeout: number = 500
): Promise<boolean> {
  return createVideoElement()
    .then(video => {
      const playPromise =
        'play' in video ? video.play()?.catch(() => undefined) : undefined;
      return hasVideoStarted(video, playPromise, timeout).then(hasStarted => {
        removeVideoElement(video);
        return hasStarted;
      });
    })
    .catch(e => {
      logError(e);
      return false;
    });
}

interface SupportAutoplayOptions {
  timeout?: number;
  logErrorsToSentry?: boolean;
  retries?: number;
}

/**
 * Retry version of deviceSupportsAutoPlay2.
 * Retry promise until autoplay is detected
 */
export function deviceSupportsAutoPlayWithRetry({
  timeout = 200,
  retries = 5,
  logErrorsToSentry = false
}: SupportAutoplayOptions): Promise<boolean> {
  const promiseWrapper = (
    handler: () => Promise<boolean>,
    ntimes: number = retries
  ): Promise<boolean> =>
    new Promise(resolve => {
      handler().then(result => {
        if (result) {
          resolve(result);
        } else if (ntimes) {
          resolve(promiseWrapper(handler, ntimes - 1));
        } else {
          resolve(false);
        }
      });
    });

  return promiseWrapper(() =>
    deviceSupportsAutoPlay2({
      timeout,
      logErrorsToSentry
    })
  );
}

export function deviceSupportsAutoPlay2({
  timeout = 650,
  logErrorsToSentry = false
}: SupportAutoplayOptions): Promise<boolean> {
  const log = (args: string) => {
    if (logErrorsToSentry) {
      logMessage(args);
    }
  };

  return new Promise(resolve => {
    const video = document.createElement('video');

    video.addEventListener('play', () => {
      resolve(true);
    });

    video.addEventListener('error', error => {
      if (video.error) {
        log(
          'autoplay test : event video error ' +
            video.error.code +
            '; details: ' +
            video.error.message
        );
      } else if (error) {
        log('autoplay test : event error ' + String(error));
      }
      resolve(false);
    });

    if (!('autoplay' in video)) {
      log('autoplay not found in video');
      resolve(false);
    }

    video.muted = true;
    video.setAttribute('muted', 'muted');
    video.loop = true;
    video.setAttribute('loop', 'loop');
    video.autoplay = true;
    video.setAttribute('autoplay', 'autoplay');

    video.style.position = 'absolute';
    video.style.top = '-500px';
    video.style.height = '200px';
    video.style.width = '300px';

    const mp4 = document.createElement('source');
    mp4.type = 'video/mp4';
    mp4.src = videoMp4Base64;

    video.appendChild(mp4);

    const body = document.getElementsByTagName('body')[0];
    body.appendChild(video);

    const removeVideoEl = () => {
      if (video.parentNode) {
        body.removeChild(video);
      }
    };

    if ('play' in video) {
      const playPromise = video.play();

      if (playPromise && playPromise instanceof Promise) {
        playPromise
          .then(() => {
            removeVideoEl();
            resolve(true);
          })
          .catch(error => {
            removeVideoEl();
            log('autoplay promise rejection' + JSON.stringify(error));
            resolve(false);
          });
      } else {
        setTimeout(() => {
          const canAutoPlay = !video.paused;
          removeVideoEl();
          if (!canAutoPlay) {
            log('autoplay not detected (legacy)');
          }
          resolve(canAutoPlay);
        }, timeout);
      }
    } else {
      removeVideoEl();
      log('autoplay no play method in the video object');
      resolve(false);
    }
  });
}

export function bytesToKiloBytes(bytes: number): number {
  return Math.round(bytes / 1000);
}

export function isVideoTooHeavy(
  contentLength: number,
  maxFileSize: number
): boolean {
  return contentLength >= maxFileSize;
}

export function getVideoContentLengthFromBase64URL(url: string): number {
  const base64Video = getVideoFromBase64URL(url);
  if (!base64Video) {
    logMessage('Unable to get video encoding from base64 string');
    return -1;
  }
  try {
    const byteCharacters = atob(base64Video);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);
    const size = blob.size;
    return bytesToKiloBytes(size);
  } catch (err) {
    logError(err as Error);
    return -1;
  }
}

export function getVideoContentLength(url: string): Promise<number> {
  return new Promise(resolve => {
    const headerKey = 'Content-Length';
    let contentLength: number = -1;

    fetch(url, { method: 'HEAD' })
      .then(res => {
        if (res.headers.has(headerKey)) {
          contentLength = parseInt(res.headers.get(headerKey) || '-1', 10);
        } else {
          logMessage('Video did not have content-length header');
        }
      })
      .catch(err => {
        logError(err);
      })
      .finally(() => {
        resolve(bytesToKiloBytes(contentLength));
      });
  });
}

export function shouldCheckVideoContentLength(): boolean {
  return Math.floor(Math.random() * 100) === 1;
}

export function getVideoFromBase64URL(url: string): string | undefined {
  return url.split(/;base64,/)[1];
}

export function isBase64VideoUrl(url: string): boolean {
  return (url || '').indexOf(';base64,') > -1;
}

interface SkinConfig {
  skinTop?: string;
  skinBottom?: string;
}

export function hasSkin(
  config: { skin?: SkinConfig } | null | undefined
): boolean {
  if (!config || !config.skin) {
    return false;
  }

  return Boolean(config.skin.skinTop || config.skin.skinBottom);
}
